import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, allowedDepartments = [], allowedRoles = [] }) => {
  const { user } = useSelector((state) => state.auth);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role permissions (admin has access to everything)
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role) && user.role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check department permissions (admin has access to everything)
  if (allowedDepartments.length > 0 && user.role !== 'admin') {
    const userDepts = user.departments || [user.department];
    const hasAccess = userDepts.some(dept => allowedDepartments.includes(dept));
    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
